import { IconProps } from "./dto";

export function MinusIcon(props: IconProps) {
    return (
        <svg width={props.size} height={props.size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.33301 8H12.6663" stroke={props.color} strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}